(() => {
  const HIDE_CLASS = "ob-variant-media-hidden";

  // Inject CSS once
  if (!document.getElementById("ob-variant-media-style")) {
    const style = document.createElement("style");
    style.id = "ob-variant-media-style";
    style.textContent = `
      .${HIDE_CLASS}{ display:none !important; }
    `;
    document.head.appendChild(style);
  }

  function getColorOptionIndex(productJson) {
    const names = ["Color", "Colour", "color", "colour"];
    const opt = (productJson.options || []).find(o => names.includes(o.name));
    if (!opt) return null;
    return (opt.position || 1) - 1;
  }

  function getSelectedColorValue(root, mediaByColor) {
    const variantSelects = root.querySelector("variant-selects");
    if (!variantSelects) return null;

    const selected = Array.from(
      variantSelects.querySelectorAll("select option:checked, fieldset input:checked")
    ).map(el => el.value);

    return selected.find(v => mediaByColor[v]);
  }

  async function initForProductInfo(productInfoEl) {
    const mediaGallery = productInfoEl.querySelector("media-gallery");
    if (!mediaGallery) return;

    const handle = productInfoEl.getAttribute("data-url")?.split("/products/")?.[1]?.split("?")?.[0];
    if (!handle) return;

    let product;
    try {
      const res = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);
      product = await res.json();
    } catch (e) {
      console.error("Variant media filter: couldn't load product JSON", e);
      return;
    }

    const colorIndex = getColorOptionIndex(product);
    if (colorIndex === null) {
      console.warn("Variant media filter: no Color/Colour option found.");
      return;
    }

    // Map colour -> [variantIds]
    const variantsByColor = {};
    product.variants.forEach(v => {
      const color = v.options?.[colorIndex];
      if (!color) return;
      (variantsByColor[color] ||= []).push(v.id);
    });

    // Map colour -> Set(mediaIds) using media.variant_ids
    const mediaByColor = {};
    (product.media || []).forEach(m => {
      const variantIds = m.variant_ids || [];
      if (!variantIds.length) return;
      for (const [color, ids] of Object.entries(variantsByColor)) {
        if (variantIds.some(id => ids.includes(id))) {
          (mediaByColor[color] ||= new Set()).add(m.id);
        }
      }
    });

    // Tag gallery nodes with data-media-group="ColourName"
    for (const [color, idSet] of Object.entries(mediaByColor)) {
      for (const mediaID of idSet) {
        const key = `${productInfoEl.getAttribute("data-section")}-${mediaID}`;

        // Main slides
        mediaGallery.querySelectorAll(`[data-media-id="${key}"]`)
          .forEach(el => el.setAttribute("data-media-group", color));

        // Thumbs (Dawn uses data-target)
        mediaGallery.querySelectorAll(`[data-target="${key}"]`)
          .forEach(el => el.setAttribute("data-media-group", color));
      }
    }

    function applyFilter() {
      const selectedColor = getSelectedColorValue(productInfoEl, mediaByColor);
      if (!selectedColor) return;

      mediaGallery.querySelectorAll("[data-media-group]").forEach(node => {
        node.classList.toggle(HIDE_CLASS, node.getAttribute("data-media-group") !== selectedColor);
      });

      // Re-init slider pagination (prevents blank pages)
      mediaGallery.querySelectorAll("slider-component").forEach(slider => {
        if (typeof slider.initPages === "function") slider.initPages();
      });
    }

    // Run immediately + on change
    applyFilter();
    productInfoEl.addEventListener("change", (e) => {
      if (e.target.closest("variant-selects")) applyFilter();
    });

    // Also run when variant changes via JS (some stores)
    productInfoEl.addEventListener("variant:change", applyFilter);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("product-info").forEach(el => initForProductInfo(el));
  });
})();
